import styled from 'styled-components';

import AditionalOptions from 'components/summary/AditionalOptions/container';

export default styled(AditionalOptions)`
  label[for^='checkbox_HAS_COMMENT_FOR_TRANSPORTIST'],
  label[for^='checkbox_HAS_INTERNAL_REFERENCE'],
  label[for^='checkbox_APPOINTMENT_INSTRUCTIONS'] {
    position: absolute;
    width: 100%;
  }
  span.label {
    margin-left: 2rem;
  }
`;
